export default __webpack_public_path__ + "static/media/eye - inactive_v1.0ce7dc88.svg";